import { Zap, Shield, Sparkles, Image, Video, Infinity as InfinityIcon } from "lucide-react";

const features = [
  {
    icon: Zap,
    title: "Instant extraction",
    body: "Grab the raw HD video file in under 3 seconds. No compression, no watermark, no waiting rooms.",
  },
  {
    icon: Video,
    title: "HD + SD variants",
    body: "Pick the exact resolution you need — perfect for teardowns, remixes, or client decks.",
  },
  {
    icon: Image,
    title: "Thumbnails included",
    body: "Every download bundles the ad's preview image so you can rebuild the creative frame-by-frame.",
  },
  {
    icon: Shield,
    title: "Private by design",
    body: "No account, no cookies, no tracking. Your download history stays in your browser — nowhere else.",
  },
  {
    icon: InfinityIcon,
    title: "Unlimited downloads",
    body: "No daily caps, no paywalls. Rip an entire competitor's ad library in one sitting.",
  },
  {
    icon: Sparkles,
    title: "Works everywhere",
    body: "Zero installs. Any browser, any device. Paste, download, done — even on mobile.",
  },
];

export default function Features() {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-20 md:py-28 border-t border-zinc-200 dark:border-zinc-800"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 lg:col-span-6">
            <p className="text-xs font-mono uppercase tracking-widest text-yellow-500 mb-3">
              // Why marketers pick us
            </p>
            <h2 className="font-display font-bold text-4xl md:text-6xl text-zinc-900 dark:text-white tracking-tight leading-[0.95]">
              Built for the ad ops teams that ship.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-zinc-400 dark:text-zinc-600 dark:text-zinc-400 text-lg leading-relaxed">
              Every feature exists to shrink the gap between spotting a great
              ad and shipping your remix. No fluff.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-zinc-200 dark:border-zinc-800">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                data-testid={`feature-${i}`}
                className="border-r border-b border-zinc-200 dark:border-zinc-800 p-8 group hover:bg-white dark:bg-zinc-950 transition-colors"
              >
                <div className="w-11 h-11 grid place-items-center border border-zinc-200 dark:border-zinc-800 group-hover:border-yellow-500 group-hover:bg-yellow-500 group-hover:text-black text-yellow-500 transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={2.5} />
                </div>
                <h3 className="mt-6 font-display font-bold text-xl text-zinc-900 dark:text-white">
                  {f.title}
                </h3>
                <p className="mt-3 text-zinc-400 dark:text-zinc-600 dark:text-zinc-400 leading-relaxed text-sm">
                  {f.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
